/* AUTO-GENERATED. Do not edit by hand. */

/**
 * @remixicon/react v4.1.0 - Apache-2.0
 */
import type { RemixiconComponentType } from '../types'

/**
 * RiLoader4Line icon component from Remix Icon set.
 * 
 * @param props - RemixiconProps
 * @returns JSX element representing the RiLoader4Line icon
 */
const RiLoader4Line: RemixiconComponentType = (props): JSX.Element => {
  // Extract RemixiconProps
  const {
    color = 'currentColor',
    size = 24,
    ...rest
  } = props

  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
      fill={color}
      width={size}
      height={size}
      {...rest}
    >
      <path fill="currentColor" d="M18.364 5.636L16.95 7.05A7 7 0 1 0 19 12h2a9 9 0 1 1-2.636-6.364"/>
    </svg>
  )
}

export default RiLoader4Line
